import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=4c5e5fa2&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e5fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5e5fa2')) {
      api.createRecord('4c5e5fa2', component.options)
    } else {
      api.reload('4c5e5fa2', component.options)
    }
    module.hot.accept("./BackToTopButton.vue?vue&type=template&id=4c5e5fa2&scoped=true", function () {
      api.rerender('4c5e5fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utility/BackToTopButton.vue"
export default component.exports